import React from "react";
import { BarChart3, Users, Clock, TrendingUp } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import EntregaFilters from "./components/EntregaFilters";
import RankingEntrega from "./components/RankingEntrega";
import StatCard from "./components/StatCard";
import TabelaPedidosPorEntregador from "./components/TabelaPedidosPorEntregador";
import {
  EstatisticasEntregaProvider,
  useEstatisticasEntrega,
} from "./context/EstatisticasEntregaContext";
import { entregaService } from "../../../services/entregaService";

const EstatisticasEntregaContent: React.FC = () => {
  const {
    startDate,
    endDate,
    selectedLojaId,
    selectedUsuarioId,
    setStartDate,
    setEndDate,
    setSelectedLojaId,
    setSelectedUsuarioId,
    handleApplyFilter,
    lojaOptions,
    usuarioOptions,
    appliedFilters,
    usuariosEntrega,
  } = useEstatisticasEntrega();

  const { data: resumo } = useQuery({
    queryKey: ["entrega-resumo", appliedFilters],
    queryFn: () =>
      entregaService.getResumo({
        dataInicio: appliedFilters.dataInicio,
        dataFim: appliedFilters.dataFim,
        lojaId: appliedFilters.lojaId || undefined,
      }),
    enabled: !!(appliedFilters.dataInicio && appliedFilters.dataFim),
  });

  const totalEntregas = usuariosEntrega.reduce(
    (acc, user) => acc + user.quantidadeEntregas,
    0
  );
  const totalEntregadores = usuariosEntrega.length;
  const tempoMedio =
    usuariosEntrega.length > 0 ? usuariosEntrega[0].tempoMedio : "00:00:00";
  const emEntrega = resumo?.totalEntregasEmAndamento || 0;

  return (
    <div className="space-y-6">
      <EntregaFilters
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        lojas={lojaOptions}
        selectedLojaId={selectedLojaId}
        onLojaChange={setSelectedLojaId}
        usuarios={usuarioOptions}
        selectedUsuarioId={selectedUsuarioId}
        onUsuarioChange={setSelectedUsuarioId}
        onApplyFilter={handleApplyFilter}
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatCard
          icon={BarChart3}
          label="Entregas Finalizadas"
          value={totalEntregas}
        />
        <StatCard icon={Users} label="Entregadores" value={totalEntregadores} />
        <StatCard icon={Clock} label="Tempo Médio" value={tempoMedio} />
        <StatCard icon={TrendingUp} label="Em Entrega" value={emEntrega} />
      </div>
      <RankingEntrega />
      <TabelaPedidosPorEntregador />
    </div>
  );
};

const EstatisticasEntrega: React.FC = () => {
  return (
    <EstatisticasEntregaProvider>
      <EstatisticasEntregaContent />
    </EstatisticasEntregaProvider>
  );
};

export default EstatisticasEntrega;
